module.exports = __webpack_public_path__ + "img/register-login.c70d14c6.png";